module.exports = __webpack_public_path__ + "static/media/ic_biometric_delete.d8f97cc3.svg";